<section class="item-list-column-wrapper">

  <section *ngIf="displayFormat == 'column'" [ngClass]="{'items-column-wrapper':displayFormat == 'column','column-container':!showCount}">
    <div class="list-itm-title">
      <span *ngIf="tableTitle">{{tableTitle | translate}} </span>
      <span *ngIf="data && displayFormat == 'column' && showCount && !showHiddenCount && data.length > 1" class="items-count">({{itemCount}}/{{data.length}})</span>
        <span *ngIf="data && displayFormat == 'column' && showHiddenCount && data.length > 1 && (data.length - itemCount > 0)" class="hidden-content-notification">{{data.length - itemCount}} Hidden items</span>
    </div>
    <gen-dynamic-form-table class="items-list"
                            [data]="tableData"
                            [formId]="formId"
                            [formVertical]="formVertical"
                            [tableVertical]="tableVertical"
                            [viewAsTable]="viewAsTable"
                            [editMode]="false"
                            [disabled] = "true"
                            [showAddButton]="false"
                            [showDeleteButton]="false"
                            [emptyMessageDisplay]="emptyMessageDisplay"
    ></gen-dynamic-form-table>
  </section>
  
  <section class="items-list-wrapper" *ngIf="displayFormat == 'list'" [ngClass]="{'items-list-viewall': !showCount}">
    <div class="list-itm-title" [ngClass]="{'showall-title': !showCount}">
      <span>{{tableTitle | translate}} </span>
    </div>

    <section class="items-list-data-wrapper"
             [ngStyle]= "{'-webkit-line-clamp' : showCount ? showCount : 'unset'}"
             genTooltip
             [tooltipShow] = "tooltipShow"
             [tooltipData]="dataList"
             [tooltipPosition]= "tooltipPosition"
             [tooltipConfiguration] = "tooltipConfiguration">
        <div class="items-list-container" *ngFor="let data of dataList; let i=index"
             [ngStyle]= "{'word-break' : showCount ? 'break-all' : 'break-word'}">
              <span *ngIf="data[items[0]]?.CommonName">{{data[items[0]]?.CommonName}}</span>
              <span *ngIf="data[items[0]]?.display">{{data[items[0]]?.display}}</span>
              <span class="second-item" *ngIf="data[items[1]]">({{data[items[1]]?.display}})</span>
              <span class="second-item" *ngIf="data[items[0]] && !data[items[0]]?.display && !data[items[0]]?.CommonName">{{data[items[0]]}}</span>
              <span class="items-seperator" *ngIf="displaySeparator(i)">,</span>
        </div>
    </section>
    <div *ngIf="!tableData || tableData.length === 0">
       <ng-container *ngIf="(emptyMessageDisplay$| async) === 'Unknown' ;else emptyMsgDiv">
      <span  [innerHTML]="translateDefaultUnknown(emptyMessageDisplay$ | async | translate) " 
      class="empty-message-display" ></span>
    </ng-container>
    <ng-template #emptyMsgDiv>
      <span class="empty-message-display" 
      [innerHTML]="(emptyMessageDisplay$| async | translate)"
      ></span>
    </ng-template>
    </div>
  </section>
<!-- TODO : Below implementation is copy paste as above which carries the tight coupling of common name and display --> 
  <section class="items-list-wrapper" *ngIf="displayFormat == 'vertical-list'" [ngClass]="{'items-list-viewall': !showCount}">
    <div class="list-itm-title" [ngClass]="{'showall-title': !showCount}" *ngIf="tableTitle">
      <span>{{tableTitle | translate}} </span>
    </div>

    <section class="items-list-data-wrapper"
             [ngStyle]= "{'-webkit-line-clamp' : showCount ? showCount : 'unset'}"
             genTooltip
             [tooltipShow] = "tooltipShow"
             [tooltipData]="dataList"
             [tooltipPosition]= "tooltipPosition"
             [tooltipConfiguration] = "tooltipConfiguration">
        <div class="vertical-list-container" *ngFor="let data of dataList; let i=index"
             [ngStyle]= "{'word-break' : showCount ? 'break-all' : 'break-word'}">
             <ul>
               <li><span *ngIf="data[items[0]]?.CommonName">{{data[items[0]]?.CommonName}}</span></li>
               <li><span *ngIf="data[items[0]]?.display">{{data[items[0]]?.display}}</span></li>
               <li><span class="second-item" *ngIf="data[items[1]]"> ({{data[items[1]]?.display}})</span></li>
               <li><span class="second-item" *ngIf="data[items[0]] && !data[items[0]]?.display && !data[items[0]]?.CommonName">{{data[items[0]]}}</span></li> 
               <li><span class="items-seperator" *ngIf="i<dataList.length-1"></span></li>
            </ul>
        </div>
    </section>
    <div *ngIf="!tableData || tableData.length === 0">
      <span class="empty-message-display">{{ emptyMessageDisplay$ | async | translate}}</span>
    </div>
  </section>


</section>
